module.exports = __webpack_public_path__ + "img/news_edit_big.e6144422.svg";